<template>
  <div class="line-box">
    <v-container class="box" fill-height>
      <v-row class="mb-6" justify="center" align="center">
        <v-col lg="10" md="10">
          <v-card class="mx-auto" style="min-width: 30%">
            <v-list-item style="background-color: #141824">
              <v-list-item-content>
                <v-list-item-title class="headline" style="color: #ffb600">
                  จัดการโฆษณา
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row>
                  <v-col>
                    <v-row>
                      <v-col lg="3" md="4">ข้อความ</v-col>
                      <v-col lg="9" md="8">
                        <v-textarea
                          outlined
                          hide-details="auto"
                          dense
                          placeholder="ข้อความ"
                          v-model="form.text"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col lg="3" md="4">ไฟล์รูปภาพ</v-col>
                      <v-col lg="9" md="8">
                        <v-file-input
                          outlined
                          v-model="file"
                          dense
                          @click:close="clearImage()"
                          @change="preview()"
                          hide-details="auto"
                          prepend-icon=""
                          accept="image/png"
                          close
                          placeholder="คลิกเพื่อเลือกรูปภาพ"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col lg="3" md="4">กลุ่มประเภทงาน</v-col>
                      <v-col lg="9" md="8">
                        <v-autocomplete
                          v-model="form.type_job"
                          :items="typeworks"
                          item-text="job_type_name"
                          item-value="job_type_id"
                          hide-details="auto"
                          outlined
                          dense
                          chips
                          small-chips
                          label="ประเภทงาน"
                          multiple
                          :rules="rules.typework"
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              close
                              small
                              class="chip--select-multi"
                              @click:close="removeType(data.item)"
                            >
                              {{ data.item.job_type_name }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template>
                              <v-list-item-content
                                v-text="data.item.job_type_name"
                              ></v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    lg="1"
                    md="0"
                    cols="0"
                    sm="0"
                    v-if="file !== null"
                  ></v-col>
                  <v-col lg="7" md="6" v-if="file !== null">
                    <v-row>
                      <v-col>
                        <v-img :src="form.urlImage" max-width="600"></v-img>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col></v-col>
                </v-row>
                <v-row>
                  <v-spacer></v-spacer>
                  <v-col>
                    <v-btn color="success" @click="sendConfirm()" block>
                      ส่งข้อมูล
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn color="error" @click="clearImage()" block>
                      ล้างรูปภาพ
                    </v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="sentDialog" max-width="350px" persistent>
      <v-card>
        <v-card-title class="headline">ยืนยันการทำรายการหรือไม่? </v-card-title>
        <v-card-text></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" small @click="send()">ยืนยัน</v-btn>
          <v-btn small color="error darken-1" text @click="closeSendConfirm()"
            >ยกเลิก</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "adsBox",
  data: () => ({
    typeworks: [],
    form: {
      text: null,
      urlImage: null,
      type_job: null,
    },
    file: null,
    sentDialog: false,
    rules: {
      validation: [(v) => !!v || "กรุณากรอกข้อมูลก่อนส่งข้อความ"],
    },
  }),
  mounted() {
    if (localStorage.getItem("username") !== null) {
      if (localStorage.getItem("role") !== "Admin") {
        alert("คุณไม่มีสิทธิ์เข้าถึงหน้านี้");
        this.$router.push("/login");
      }
      //----------
    }
              if (localStorage.getItem("username") === undefined) {
            alert("กรุณาลงชื่อเข้าสู่ระบบก่อน");
            this.$router.push("/login");
          } else {
            this.getAllJob();
          }
    // this.$axios
    //   .post(this.api + "/checkversion", { version: this.version.split(" ")[3] })
    //   .then((res) => {
    //     if (res.data.status) {
    //       if (localStorage.getItem("username") === undefined) {
    //         alert("กรุณาลงชื่อเข้าสู่ระบบก่อน");
    //         this.$router.push("/login");
    //       } else {
    //         this.getAllJob();
    //       }
    //     }
    //   });
  },
  methods: {
    removeProvince(item) {
      let index = this.form.province.indexOf(item.id);
      if (index >= 0) this.form.province.splice(index, 1);
    },
    getAllJob() {
      this.$axios.get(this.api + "/all/typejob").then((res) => {
        if (res.data.status) {
          this.typeworks = res.data.response;
        }
      });
    },
    closeSendConfirm() {
      this.sentDialog = false;
    },
    sendConfirm() {
      this.sentDialog = true;
    },
    send() {
      this.$axios.post(this.api + "/send/ads", this.form).then((res) => {
        if (res.data.status) {
          location.reload();
        }
      });
    },
    clearImage() {
      this.form.urlImage = null;
      this.file = null;
    },
    preview() {
      var input = event.target;
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.form.urlImage = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
  },
};
</script>

<style></style>
